var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuStarBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7375 6.78L11.1075 6.465L9.68999 3.1275C9.43499 2.52 8.56499 2.52 8.30999 3.1275L6.89249 6.4725L3.26999 6.78C2.60999 6.8325 2.33999 7.6575 2.84249 8.0925L5.59499 10.4775L4.76999 14.0175C4.61999 14.6625 5.31749 15.1725 5.88749 14.8275L8.99999 12.9525L12.1125 14.835C12.6825 15.18 13.38 14.67 13.23 14.025L12.405 10.4775L15.1575 8.0925C15.66 7.6575 15.3975 6.8325 14.7375 6.78ZM8.99999 11.55L6.17999 13.2525L6.92999 10.0425L4.43999 7.8825L7.72499 7.5975L8.99999 4.575L10.2825 7.605L13.5675 7.89L11.0775 10.05L11.8275 13.26L8.99999 11.55Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuStarBorder);
export default __webpack_public_path__ + "static/media/du-star-border.03e3789a4c72256e959dab01886979cb.svg";
export { ForwardRef as ReactComponent };